<template>
  <div class="postRole">
    <a-collapse v-model="activeKey">
      <a-collapse-panel key="1">
        <template slot="header">
          <div>
            <a-icon slot="extra" type="bank" />
            <span>公司-角色岗位</span>
          </div>
        </template>
        <a-checkbox-group
          v-if="isCheck"
          v-model="checkValue"
          name="checkboxgroup"
        >
          <div class="checkBox">
            <a-checkbox v-for="item in treeData"
              :key="item.roleId"
              :value="item"
              @change="onChange"
            >
            {{ item.roleName }}
            </a-checkbox>
          </div>
        </a-checkbox-group>
        <a-radio-group v-else v-model="radioValue" class="radioList">
          <a-radio
            v-for="item in treeData"
            :key="item.roleId"
            :value="item"
            @change="radioChange"
          >
          {{ item.roleName }}
          </a-radio>
        </a-radio-group>
      </a-collapse-panel>
    </a-collapse>
    <!-- <a-tree
      :treeData="treeData"
      show-icon
      checkable
      :replaceFields="replaceFields"
      @select="onSelect"
      >
      <a-icon slot="bank" type="bank" />
      <a-icon slot="apartment" type="apartment" />
    </a-tree> -->

  </div>
</template>

<script>
export default {
  name: 'PostRole',
  props: {
    postRoleList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isCheck: true,
      radioValue: [],
      activeKey: '1',
      checkValue: [],
      treeData: [],
      replaceFields: {
        children: 'children',
        key: 'roleId',
        title: 'roleName'
      }
    }
  },
  watch: {
    // postRoleList: {
    //   handler (val) {
    //     this.getPostList(val)
    //   },
    //   immediate: true
    // }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.$get('/role', { pageSize: 10000, pageNum: 1 }).then(res => {
        let arr = res.data.rows
        if (arr.length) {
          this.treeData = arr
          if (this.postRoleList.length) {
            if (this.isCheck) {
              this.getPostList(this.postRoleList)
            } else {
              this.getRadioData()
            }
          }
        }
      })
    },
    getRadioData () {
      this.radioValue = []
      if (this.postRoleList[0]) {
        this.treeData.map(i => {
          if (this.postRoleList[0].roleId === i.roleId) {
            this.radioValue = i
          }
        })
      }
    },
    getPostList (arr) {
      if (arr.length) {
        this.checkValue = []
        this.$nextTick(() => {
          this.treeData.forEach(item => {
            arr.forEach(i => {
              if (item.roleId === i.roleId) {
                item.checked = true
                this.checkValue.push(item)
              }
            })
          })
        }, 500)
      }
    },
    // 获取选中的人员
    onChange (e) {
      this.$emit('changeRoleValue', e.target, e.target.value)
    },
    radioChange (e) {
      this.$emit('changeRoleValue', e.target, e.target.value)
    },
    // 清除选中的人员
    deleteRole (item) {
      this.checkValue = this.checkValue.filter(i => i.roleName !== item.roleName)
    }
  }
}
</script>

<style lang="less" scoped>
.radioList{
  display: flex;
  flex-direction: column;
}
.checkBox {
  display: flex;
  flex-direction: column;
  .ant-checkbox-wrapper:first-child {
    margin-left: 8px;
  }
  .ant-collapse-content {
    border:none;
  }
}
/deep/ .ant-collapse-header {
  background: #ffffff;
}
// /deep/ .ant-collapse-content-box {
//   padding-top: 0;
// }
</style>



// WEBPACK FOOTER //
// src/components/personnel/postRole.vue